module.exports = __webpack_public_path__ + "img/phone.75cfd109.png";